import { useState, useEffect } from "react";
import { getChatJobOffers } from "../../services/ivrModule/jobServices.js";

const useChatJobOfferPolling = (workerId, intervalMs = 5000) => {
  const [jobOffer, setJobOffer] = useState(null);
  const [blink, setBlink] = useState(false);

  useEffect(() => {
    let intervalId;

    const pollOffers = async () => {
      try {
        const offer = await getChatJobOffers(workerId);
        if (offer && Object.keys(offer).length > 0) {
          setJobOffer(offer);
        } else {
          setJobOffer(null);
        }
      } catch (err) {
        console.error("❌ Error polling chat job offers:", err);
        setJobOffer(null);
      }
    };

    pollOffers(); // initial call
    intervalId = setInterval(pollOffers, intervalMs);

    return () => clearInterval(intervalId);
  }, [workerId, intervalMs]);

  useEffect(() => {
    if (!jobOffer) {
      setBlink(false);
      return;
    }

    const blinkInterval = setInterval(() => setBlink(prev => !prev), 500);
    return () => clearInterval(blinkInterval);
  }, [jobOffer]);

  return { jobOffer, setJobOffer, blink, setBlink };
};

export default useChatJobOfferPolling;
